import { computed } from "vue"
import { useStore } from "vuex"

export function useUser() {
  const store = useStore()
  const user = computed(() => store.state.user.user)
  const pending = computed(() => store.state.user.pending)
  const addresses = computed(() => store.state.user.addresses || [])

  const defaultAddress = computed(
    () => store.getters['user/defaultAddress']
  )

  const countryPhoneCodes = computed(() => store.state.user.countryPhoneCodes)
  const isNewsletterSubscribed = computed(() => store.getters['user/isNewsletterSubscribed'])
  
  const getUser = () => store.dispatch('user/getUser')
  const getNewsletter = () => store.dispatch('user/getNewsletter')
  const getAddresses = () => store.dispatch('user/getAddresses')
  const createAddress = (payload) => store.dispatch('user/createAddress', payload)
  const updateAddress = (payload) => store.dispatch('user/updateAddress', payload)

  return {
    user,
    getUser,
    getNewsletter,
    pending,
    addresses,
    getAddresses,
    createAddress,
    updateAddress,
    defaultAddress,
    countryPhoneCodes,
    isNewsletterSubscribed,
  }
}
